import isEmpty from 'lodash-es/isEmpty'
import mapValues from 'lodash-es/mapValues'
import omitBy from 'lodash-es/omitBy'
import * as queryString from 'query-string'

import { ILocationParams } from '../../reducers/reactRouterLocation'
import { encodeLocationParam } from './format'

const URL_SANITIZE_REGEXP = /<|>/g

export const sanitizeQueryParams = (
  params: ILocationParams
): ILocationParams => {
  return mapValues(omitBy(params, isEmpty), value =>
    securitySanitize(value || '')
  )
}

export const sanitizeLocationParam = (
  param: string,
  delimiter: string = ','
) => {
  return securitySanitize(param)
    .split(delimiter)
    .map(encodeLocationParam)
    .join('+')
}

export const securitySanitize = (value: string) =>
  value.replace(URL_SANITIZE_REGEXP, '')

export const getSanitizedUrl = securitySanitize
